module.exports = __webpack_public_path__ + "img/7_106.6452f5a7.png";